import makeUseProduct, { TYPES } from './makeUseProduct.factory'

const useSwatch = makeUseProduct(TYPES.SWATCH)

export default useSwatch
